<div class="ap-cr-full-height">
  <ng-container *ngIf="loading">
    <kendo-loader [type]="'converging-spinner'" [size]="'large'"  [themeColor]="'secondary'"></kendo-loader>
  </ng-container>
    <ng-container *ngFor="let item of fields; let index = index">
      <div class="ap-cr-row-main-data-box" (click)="selectField($event, item.Id)"
           [style.background-color]="findItem(item.Id) ? 'rgba(176, 203, 31, 0.25)' : null">
        <div class="ap-cr-column-box-middle-34px-border-left">
          <input type="checkbox"
                 class="k-checkbox"
                 [id]="item.Id + '_grid_selector'"
                 [checked]="findItem(item.Id)"
                 (change)="toggleFieldSelection(item.Id)" />
          <label class="k-checkbox-label ap-cr-flex-box-margin-11px"
                 [for]="item.Id + '_grid_selector'"></label>
        </div>
        <div class="ap-cr-column-box-middle-33px">
          <ap-status-column-cell [config]="statusConfig" [dataItem]="{Id:item.Id,Status:1,StatusClass:'ap-status-green'}"></ap-status-column-cell>
        </div>
        <div class="ap-cr-column-box-middle-50px ap-cr-cell-right-aligned">
          <ap-responsive-text [text]="item.FieldNumber"></ap-responsive-text>
        </div>
        <div class="ap-cr-column-box-middle-60px ap-cr-cell-right-aligned">
          <ap-responsive-text [text]="item.FieldSubNumber"></ap-responsive-text>
        </div>
        <div class="ap-cr-column-box-middle-163px">
          <button [disabled]="!item.Children || item.Children.length < 1"
                  kendoButton
                  class="ap-cr-extend-button k-button k-primary button-important"
                  [class.ap-cr-extend-button-active]="visibleState[item.Id] === 'in'"
                  [svgIcon]="!item.Children || item.Children.length < 1 ? '' : visibleState[item.Id] === 'in' ? ApKendoIconService.Get('minusIcon') : ApKendoIconService.Get('plusIcon')"
                  (click)="switchVisibleState(item.Id.toString())"
          ></button>
          <ap-responsive-text class="ap-cr-field-name" [text]="item.FieldName"></ap-responsive-text>
        </div>
        <div class="ap-cr-column-box-middle-50px ap-cr-cell-right-aligned">
          <ap-responsive-text [text]="(item.AreaHa | getRoundNumeric:numericRound).toString()"></ap-responsive-text>
        </div>
        <div class="ap-cr-value-column-wrapper">
          <div class="ap-cr-value-column"
               *ngFor="let year of yearInterval"
               [style.min-width.px]="columnWidth + (year === 0 ? -1 : 0)"
               [style.max-width.px]="columnWidth + (year === 0 ? -1 : 0)"
               [class.ap-cr-cell-marked]="year === 0">
            <ap-crop-rotation-detail [id]="'crop_rotation_cell_' + index + '_' + year"
                                     [data]="item | toCellValue:[year, currentYear]"
                                     [fieldIsActive]="item | fieldIsActive:[year, currentYear]"
                                     [mappedChildCropTypes]="item | getMappedChildren:year"
                                     [availableCropTypes]="availableCropTypes"
                                     [strawHarvestedId]="item | idCreator:year"
                                     [saving]="saving | getSavingState:[item.Id,currentYear+year]"
                                     [disableControls]="saving | getSavingState:[item.Id,currentYear+year]"
                                     (saveCell)="saveCell.emit($event)"
                                     (getFocus)="getFocus.emit($event)"
                                     (lostFocus)="lostFocus.emit($event)"
            ></ap-crop-rotation-detail>
          </div>
        </div>
        <div class="ap-cr-value-filler"></div>
      </div>
      <div [style.overflow]="'hidden'"
           [style.height.px]="75*item.Children.length"
           *ngIf="visibleValues[item.Id]">
        <ng-container *ngFor="let child of item.Children;index as j">
          <div class="ap-cr-row-data-box">
            <div class="ap-cr-column-box-middle-placeholder-61px">
              <ap-responsive-text [text]="child.FieldNumber"></ap-responsive-text>
            </div>
            <div class="ap-cr-column-box-middle-50px">
              <ap-responsive-text [text]="child.FieldSubNumber"></ap-responsive-text>
            </div>
            <div class="ap-cr-column-box-middle-180px">
              <ap-responsive-text [text]="child.FieldName"></ap-responsive-text>
            </div>
            <div class="ap-cr-column-box-middle-50px ap-cr-cell-right-aligned">
              <ap-responsive-text [text]="(child.AreaHa | getRoundNumeric:numericRound).toString()"></ap-responsive-text>
            </div>
            <div class="ap-cr-value-column-wrapper">
              <div class="ap-cr-value-column"
                   *ngFor="let year of yearInterval"
                   [style.min-width.px]="columnWidth + (year === 0 ? 0 : -0.25)"
                   [style.max-width.px]="columnWidth + (year === 0 ? 0 : -0.25)"
                   [class.ap-cr-cell-marked]="year === 0">
                <ap-crop-rotation-detail [availableCropTypes]="availableCropTypes"
                                         [fieldIsActive]="child | fieldIsActive:[year, currentYear]"
                                         [strawHarvestedId]="child | idCreator:year"
                                         [disableControls]="true"
                                         [data]="child | toCellValue:[year, currentYear]"
                ></ap-crop-rotation-detail>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
</div>
